import TreeSelectorNode from "./TreeSelectorNode";

export default class TreeSelectorModel {

    items = [];
    //文本数组,key数组
    selected = [];

    itemKey = 'id';
    itemText = 'name';
    itemChildren = 'children';
    selectionType = '1';
    multiSelect = false;

    nodes = [];
    nodeMap = new Map();
    visible = [];
    selectedMap = new Map();

    constructor(items) {
        this.items = items;
    }
    //要在设置数据前设置
    setItemOption (itemKey, itemText, itemChildren) {
        this.itemKey = itemKey;
        this.itemText = itemText;
        this.itemChildren = itemChildren;
    }

    setSelectionType (selectionType) {
        this.selectionType = selectionType;
    }

    setSelectionCheck (selectionCheck) {
        this.selectionCheck = selectionCheck;
    }

    setMultiSelect (multiSelect) {
        this.multiSelect = multiSelect;
    }

    setItems (newItems) {
        if (this.items == newItems)
            return;
        if (!newItems)
            this.items = [];
        else
            this.items = newItems;

        this.applyItems();
        this.applySelected();
        this.collectVisibleItems();
    }

    applyItems () {
        this.nodes = [];
        this.nodeMap = new Map();
        this.initNodes(this.items, 1, null);
    }

    initNodes (items, level, parentNode) {
        let me = this;

        items.forEach(function (item) {
            let node = new TreeSelectorNode(item);
            me.nodes.push(node);
            me.nodeMap.set(item[me.itemKey], node);
            node.setParent(parentNode);
            if (parentNode)
                parentNode.addChild(node);
            node.setLevel(level);
            node.setOpened(false);
            //0部分选择 1 选择 -1未选
            node.setSelectState(-1);
            node.setEditState(-1);
            if (item[me.itemChildren])
                me.initNodes(item[me.itemChildren], level + 1, node);
        });
    }

    //文本数组
    setSelected (selected) {
        this.selected = selected;
        this.applySelected();
    }

    applySelected(){
        let me = this;
        this.nodes.forEach(function (node) {
            node.setSelectState(-1);
            node.setEditState(-1);
        });

        this.selected.forEach(function (key) {
            let node = me.nodeMap.get(key);
            if (node) {
                me.doSelect(node.getItem(), false);
            }
        });
    }

    getVisible () {
        return this.visible;
    }

    canOpen (item) {
        let node = this.nodeMap.get(item[this.itemKey]);
        if (node) {
            return this.hasLower(node) && (!node.isOpened());
        } else {
            return false;
        }
    }

    canClose (item) {
        let node = this.nodeMap.get(item[this.itemKey]);
        if (node) {
            return this.hasLower(node) && (node.isOpened());
        } else {
            return false;
        }
    }

    hasLower (node) {
        return node && node.getChildren() && node.getChildren().length > 0;
    }

    open (item) {
        let node = this.nodeMap.get(item[this.itemKey]);
        if (node) {
            node.setOpened(true);
            this.collectVisibleItems();
        }

    }

    close (item) {
        let node = this.nodeMap.get(item[this.itemKey]);
        if (node) {
            node.setOpened(false);
            this.collectVisibleItems();
        }
    }

    itemVisible (item) {
        let node = this.nodeMap.get(item[this.itemKey]);
        let visible = this.nodeVisible(node);
        
        return visible;
    }

    nodeVisible (node) {
        if (node) {
            let parent = node.getParent()
            if (!parent)
                return true;
            else
                return parent.isOpened() && this.nodeVisible(parent);
        } else
            return true;
    }

    collectVisibleItems () {
        let visible = [];
        let me = this;
        me.nodes.forEach(function (node) {
            me.collectVisibleByNode(visible, node);
        });

        me.visible = visible;
    }

    collectVisibleByNode (visible, node) {
        let me = this;
        let nodeVisible = me.nodeVisible(node);
        if (nodeVisible) {
            let item = node.getItem();
            //console.log("node:"+item[this.itemKey]+"-"+item[this.itemText]+"-"+nodeVisible);
            visible.push(item);
            if (node.getChildren && node.getChildren() > 0) {
                node.getChildren().forEach(function (childNode) {
                    me.collectVisibleByNode(visible, childNode);
                });
            }
        }
    }

    getItemSelectState (item) {
        let node = this.nodeMap.get(item[this.itemKey]);
        return node.getSelectState();
    }

    getItemLevel (item) {
        let node = this.nodeMap.get(item[this.itemKey]);
        return node.getLevel();
    }

    //如果是单选，不能启动连带选择
    getSelectionType () {
        if (!this.multiSelect) {
            return 1;
        }
        return this.selectionType;
    }

    doSelect (item, editing) {
        //console.log("tree Selector model do select");
        //console.log(item);
        //console.log(editing);
        if(this.selectionCheck && !this.selectionCheck(item))
            return;
        
        let me = this;
        if (item) {
            let node = this.nodeMap.get(item[this.itemKey]);

            if(!this.multiSelect){
                this.nodes.forEach(function (node) {
                    node.setSelectState(-1);
                    node.setEditState(-1);
                });
            }

            if (this.getSelectionType() == 2)
                this.selectNodeState(node, 1, true, true, editing);
            else
                this.selectNodeState(node, 1, false, false, editing);
        }
    }

    doUnSelect (item, editing) {
        let me = this;
        if (item) {
            let node = this.nodeMap.get(item[this.itemKey]);
            if (this.getSelectionType() == 2)
                this.selectNodeState(node, -1, true, true, editing);
            else
                this.selectNodeState(node, -1, false, false, editing);
        }
    }

    selectLowerNodeState (node, state, cascadeChildren, needCheckParentState, editing) {
        let me = this;
        if ((state != 1) && (state != -1)) {
            throw new Error('parameter state must in (1,-1)');
            return;
        }
        //先选中所有子节点
        let children = node.getChildren();
        if (children) {
            children.forEach(function (childNode) {
                childNode.setEditState(state);
                if (!editing)
                    childNode.setSelectState(state);
                if (cascadeChildren)
                    me.selectLowerNodeState(childNode, state, cascadeChildren, needCheckParentState, editing);
            });
        }
    }

    selectNodeState (node, state, cascadeChildren, needCheckParentState, editing) {
        if ((state != 1) && (state != -1)) {
            throw new Error('parameter state must in (1,-1)');
            return;
        }

        if (cascadeChildren == true) {
            this.selectLowerNodeState(node, state, cascadeChildren, needCheckParentState, editing);
        }

        node.setEditState(state);
        if (!editing)
            node.setSelectState(state);
        if (needCheckParentState) {
            this.selectCheckParentNode(node, needCheckParentState, editing);
        }
    }

    selectCheckParentNode (node, cascadeParent, editing) {
        let me = this;
        let parentNode = node.getParent();
        if (parentNode) {
            let newState = -1;
            let childrenAllSelectedState = this.getChildrenAllSelectedState(parentNode, editing);
            if (childrenAllSelectedState == 1) {
                newState = 1;
            } else if (childrenAllSelectedState == -1) {
                newState = -1;
            } else {
                newState = 0;
            }

            parentNode.setEditState(newState);
            if (!editing)
                parentNode.setSelectState(newState);
            if (cascadeParent)
                me.selectCheckParentNode(parentNode, cascadeParent, editing);
        }
    }

    getChildrenAllSelectedState (node, editing) {
        let me = this;
        let foundSelected = false;
        let foundUnSelected = false;
        let foundSomeSelected = false;

        let children = node.getChildren();
        children.forEach(function (childNode) {
            let state = editing ? childNode.getEditState() : childNode.getSelectState();
            if (state == 1)
                foundSelected = true;
            else if (state == -1)
                foundUnSelected = true;
            else
                foundSomeSelected = true;
        });
        if (((foundSelected == true) && (foundUnSelected == true)) || (foundSomeSelected == true))
            return 0;
        else if (foundSelected)
            return 1;
        return -1;
    }
    //根据editState计算返回值
    //是否需要增加配置，在多级连带选择模式下，只返回末级节点（暂未提供）
    getSelectedItems () {
        console.log("开始查询编辑状态选择值");
        let me = this;
        let selected = [];
        this.nodes.forEach(function (node) {
            //me.collectSelectedItems(selected,node);
            if (node.getEditState() == 1)
                selected.push(node.getItem());
        });
        console.log(selected);
        return selected;
    }

}